// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-form {
  background: #fff;
  width: 300px;
  margin: 10px auto;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0 2px 25px rgba(0, 0, 0, 0.2);
  float: left;
}
.search-form .search-action {
  display: flex;
  flex-direction: row;
}
.search-form .search-action input {
  margin-left: 4%;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: medium;
  width: 70%;
  padding: 10px;
  border: 0;
  border-bottom: 1px solid #747474;
  outline: none;
  transition: all 0.2s;
  font-weight: bold;
}
.search-form .search-action input::-webkit-input-placeholder, .search-form .search-action input::-moz-placeholder, .search-form .search-action input:-ms-input-placeholder, .search-form .search-action input::placeholder {
  text-transform: uppercase;
}
.search-form .search-action input:focus {
  border-bottom: 2px solid var(--primary_body_color);
}
.search-form .search-action button {
  display: inline-block;
  margin: auto;
  border: none;
  padding: 10px;
  cursor: pointer;
  text-transform: capitalize;
  background: var(--solo_button_back_colour);
  color: var(--solo_button_text_colour);
  letter-spacing: 0.2px;
  outline: 0;
  transition: all 0.3s;
  font-weight: 900;
  margin-right: 2px;
}
.search-form .search-action button.set_btn {
  background-color: var(--solo_button_back_colour);
  color: var(--solo_button_text_colour);
}
.search-form .search-action button.set_btn:hover {
  background: var(--solo_button_back_colour);
}
.search-form .search-action button.cancel_btn {
  background-color: #e6dede;
  color: var(--solo_button_back_colour);
}
.search-form .search-action button.cancel_btn:hover {
  background: #d8d8d8;
}`, "",{"version":3,"sources":["webpack://./src/app/components/searchbox/searchbox.component.scss"],"names":[],"mappings":"AACA;EAEI,gBAAA;EACA,YAAA;EACA,iBAAA;EAEA,aAAA;EAGA,sBAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;AADJ;AAGI;EAGE,aAAA;EAGA,mBAAA;AAFN;AAMM;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EAEA,oBAAA;EACA,iBAAA;AAJR;AAMQ;EAIE,yBAAA;AAPV;AAUQ;EACE,kDAAA;AARV;AAYM;EACE,qBAAA;EAIA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,0CAAA;EACA,qCAAA;EACA,qBAAA;EACA,UAAA;EAEA,oBAAA;EACA,gBAAA;EACA,iBAAA;AAbR;AAeQ;EACE,gDAAA;EACA,qCAAA;AAbV;AAeU;EACE,0CAAA;AAbZ;AAiBQ;EACE,yBAAA;EACA,qCAAA;AAfV;AAiBU;EACE,mBAAA;AAfZ","sourcesContent":["\r\n.search-form {\r\n\r\n    background: #fff;\r\n    width: 300px;\r\n    margin: 10px auto;\r\n    display: -webkit-box;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    flex-direction: column;\r\n    border-radius: 4px;\r\n    box-shadow: 0 2px 25px rgba(0, 0, 0, 0.2);\r\n    float: left;\r\n  \r\n    .search-action {\r\n  \r\n      display: -webkit-box;\r\n      display: flex;\r\n      -webkit-box-orient: horizontal;\r\n      -webkit-box-direction: normal;\r\n      flex-direction: row;\r\n      // margin: 10px auto;\r\n  \r\n  \r\n      input {\r\n        margin-left: 4%;\r\n        margin-bottom: 3px;\r\n        display: flex;\r\n        align-items: center;\r\n        flex-wrap: wrap;\r\n        font-size: medium;\r\n        width: 70%;\r\n        padding: 10px;\r\n        border: 0;\r\n        border-bottom: 1px solid #747474;\r\n        outline: none;\r\n        -webkit-transition: all .2s;\r\n        transition: all .2s;\r\n        font-weight: bold;\r\n  \r\n        &::-webkit-input-placeholder,\r\n        &::-moz-placeholder,\r\n        &:-ms-input-placeholder,\r\n        &::placeholder {\r\n          text-transform: uppercase;\r\n        }\r\n  \r\n        &:focus {\r\n          border-bottom: 2px solid var(--primary_body_color);\r\n        }\r\n      }\r\n  \r\n      button {\r\n        display: inline-block;\r\n        // width: 100%;\r\n        // width: fit-content;\r\n        // min-width: 140px;\r\n        margin: auto;\r\n        border: none;\r\n        padding: 10px;\r\n        cursor: pointer;\r\n        text-transform: capitalize;\r\n        background:  var(--solo_button_back_colour);\r\n        color: var(--solo_button_text_colour);\r\n        letter-spacing: 0.2px;\r\n        outline: 0;\r\n        -webkit-transition: all .3s;\r\n        transition: all .3s;\r\n        font-weight: 900;\r\n        margin-right: 2px;\r\n  \r\n        &.set_btn {\r\n          background-color: var(--solo_button_back_colour);\r\n          color: var(--solo_button_text_colour);\r\n  \r\n          &:hover {\r\n            background:  var(--solo_button_back_colour);\r\n          }\r\n        }\r\n  \r\n        &.cancel_btn {\r\n          background-color: #e6dede;\r\n          color: var(--solo_button_back_colour);\r\n  \r\n          &:hover {\r\n            background: #d8d8d8;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
